import * as yup from "yup";
import { YEARS_PAST_PET } from "../../config/params";
import { subtractYearsToDate } from "../../utils";

export const PetOneSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required("Pet name is required"),
  species: yup
    .string()
    .required("Specie is required"),
  breed: yup
    .string()
    .when(["species"],
      {
        is: (species: string) => species !== "3",
        then: yup
          .string()
          .required("Breed is required"),
        otherwise: yup
          .string(),
      },
    ),
  idColor: yup
    .string(),
  gender: yup
    .string()
    .required(),
  isDesexed: yup
    .string(),
  anyMedicalRecord: yup.string().default("0"),
  medicalRecordCity: yup
    .string()
    .when(["anyMedicalRecord"],
      {
        is: (anyMedicalRecord: string) => anyMedicalRecord === "1",
        then: yup.string().required("City is required"),
        otherwise: yup.string().nullable(true).notRequired(),
      },
    ),
  medicalRecordName: yup
    .string()
    .when(["anyMedicalRecord"],
      {
        is: (anyMedicalRecord: string) => anyMedicalRecord === "1",
        then: yup.string().required("Veterinarian is required"),
        otherwise: yup.string().nullable(true).notRequired(),
      },
    ),

});

export const PetTwoSchema = yup.object({
  knowBirthday: yup
    .string()
    .required(),
  birthdate: yup
    .date()
    .when(["knowBirthday"],
      {
        is: (knowBirthday: string) => knowBirthday === "1",
        then: yup
          .date()
          .required()
          .min(subtractYearsToDate(new Date(), YEARS_PAST_PET))
          .max(new Date()),
        otherwise: yup
          .date()
          .nullable(true)
          .notRequired(),
      },
    ),
});


export const PetSchema = yup.object({
  name: yup.string().trim().required("Pet name is required"),
  species: yup.string().required("Species is required"),
  breed: yup.string().when("species", {
    is: (species: string) => species !== "3",
    then: yup.string().required("Breed is required"),
    otherwise: yup.string(),
  }),
  gender: yup.string().required(),
  isDesexed: yup.string(),
  anyMedicalRecord: yup.string().default(""),
  medicalRecordCity: yup.string().when("anyMedicalRecord", {
    is: (anyMedicalRecord: string) => anyMedicalRecord == "1",
    then: yup.string().required("City is required"),
    otherwise: yup.string().nullable(true).notRequired(),
  }),
  medicalRecordName: yup.string().when("anyMedicalRecord", {
    is: (anyMedicalRecord: string) => anyMedicalRecord=="1",
    then: yup.string().required("Veterinarian is required"),
    otherwise: yup.string().nullable(true).notRequired(),
  }),
  // eslint-disable-next-line max-len
  birthdate: yup.date().nullable().default(null).test(
    "required",
    "Birthdate is required",
    (value) => value !== null && value !== undefined,
  ).min(subtractYearsToDate(new Date(), YEARS_PAST_PET)).max(new Date()),
});
export type PetFormType = yup.InferType<typeof PetSchema>
export type PetOneFormType = yup.InferType<typeof PetOneSchema>;
export type PetTwoFormType = yup.InferType<typeof PetTwoSchema>;
